module.exports = __webpack_public_path__ + "img/pen-yellow.d5ca9369.svg";